export const companiesInfo = {
  "Trumac Healthcare": {
    name: "Trumac Healthcare",
    address: "Plot 231, Phase-1, Industrial Area, Panchkula, Haryana (134113)",
    website: "www.trumachealthcare.net",
  },
  "Camrut Pharma": {
    name: "Camrut Pharma",
    address: "Plot 231, Phase-1, Ind Area, Panchkula, Haryana (134113)",
    website: "www.camrut.com",
  },
  "Medisync Pharma": {
    name: "Medisync Pharma",
    address: "Plot 231, Phase-1, Ind Area, Panchkula, Haryana (134113)",
    website: "www.medisyncpharma.com",
  },
  // ... add more companies as needed
};
